import { isBefore as isBeforeFns } from 'date-fns';

export default function isBefore(date: Date, dateToCompareTo: Date): boolean {
  return isBeforeFns(date, dateToCompareTo);
}
